import React from "react";
import SectionCommonTable from "../../components/SectionCommonTable";
import WithdrawReportStatusTable from "./table/withdrawReportStatusTable";

const ReportStatusPage = () => {
  return (
    <SectionCommonTable
      wrapperClassName="withdrawreportstatus_table"
      cardStyle={{ backgroundColor: "#fff" }}
      sectionTableTitle="Withdraw Request"
      table={<WithdrawReportStatusTable />}
    />
  );
};

export default ReportStatusPage;
